import { Fancybox } from '@fancyapps/ui';
import { Browser } from 'smg/browser';
import { GetCartID } from 'smg/customer-api/v2/carts';
import { GetPageRequestID } from 'smg/customer-api/pagerequests';
import * as errors from 'smg/errors';
import * as session from 'smg/customer-api/session';

import { SetBootstrapVersion } from 'smg/bootstrap';
import { SetIconLibrary } from 'smg/icons';
import * as carts from './carts';

declare interface myWindow extends Window {
    getPageRequestID: typeof GetPageRequestID;
}
declare const window: myWindow;

window.getPageRequestID = GetPageRequestID;

errors.InitClientSideErrorLogging();

SetIconLibrary('fontAwesome5');
SetBootstrapVersion(5);

Fancybox.bind('[data-fancybox]');

function initCart() {
    if (!GetCartID()) {
        return;
    }
    carts.GetCartCount().then(count => {
        if (!count) {
            return;
        }
        carts.IncrementCartCount(count);
    }).catch(err => console.error(`failed to get cart count: ${String(err)}`));
}

async function main() {
    await session.ConsumeLoginTokenFromURL();
    // Page tracking starts after the exchange so the page request belongs to the
    // account the link signed in, not whoever was signed in before.
    void GetPageRequestID();

    initCart();

    document.body.classList.add(`browser-${Browser()}`);

    // TODO fix small unhover effect when cursor over pseudo element
    const dropdownMenus = Array.from(document.querySelectorAll('.dropdown-toggle')) as HTMLElement[];
    for (const dropdown of dropdownMenus) {
        dropdown.addEventListener('mouseover', () => {
            dropdown.classList.add('show');
            dropdown.nextElementSibling?.classList.add('show');
        });
        dropdown.nextElementSibling?.addEventListener('mouseover', () => {
            dropdown.classList.add('show');
            dropdown.nextElementSibling?.classList.add('show');
        });
        dropdown.parentElement?.parentElement?.addEventListener('mouseout', () => {
            dropdown.classList.remove('show');
            dropdown.nextElementSibling?.classList.remove('show');
        });
    }
}

void main();
